module.exports = __webpack_public_path__ + "static/media/BgGroupRule.4a3b75b0.png";